import getConfig from "next/config"

const loadEnv = () => getConfig().publicRuntimeConfig.process.env

const getLogObject = (level, message, environment, data, attributes) => ({
    "@timestamp": new Date(),
    message: message,
    level: level,
    source_app: "make-it-butter",
    environment: environment,
    ...(attributes ? { ...attributes } : {}),
    ...(data ? { more_info: JSON.stringify(data) } : null),
})

const log = (level, message, data, attributes) => {
    const envVars = loadEnv()

    if (envVars.NODE_ENV === "development") {
        // eslint-disable-next-line no-console
        console.log(message, data, attributes)
    } else if (typeof window !== "undefined") {
        const url = new URL(window.location.href)
        fetch(`${url.origin}/log`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                message: message,
                data: data,
                level: level,
                attributes: attributes,
            }),
        }).catch((err) => {
            console.error(err)
        })
    } else {
        // eslint-disable-next-line no-console
        console.log(JSON.stringify(getLogObject(level, message, envVars.ENVIRONMENT, data, attributes)))
    }
}

export default {
    log: log,
    info: (message: string, data?: {}, attributes?: {}) => log("info", message, data, attributes),
    warn: (message: string, data?: {}, attributes?: {}) => log("warn", message, data, attributes),
    error: (message: string, data?: {}, attributes?: {}) => log("error", message, data, attributes),
}
